import { Button } from "antd";
import { useNavigate } from "react-router-dom";

function AccessDeniedPage() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 100,
      }}
    >
      <div
        className="shadow-2xl"
        style={{
          width: "30%",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 250,
          fontFamily: "Poppins",
          padding: 20,
          borderRadius: 8.5,
          paddingLeft: 50,
          paddingRight: 50,
          paddingTop: 22,
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            gap: 12,
          }}
        >
          <div style={{ fontFamily: "Poppins", fontSize: 50 }}>403</div>
          <div style={{ fontFamily: "Poppins", fontSize: 22 }}>
            Access denied
          </div>
          <div style={{ textAlign: "center" }}>
            You are not allowed to access this page.
          </div>
          <Button onClick={() => navigate("/")} type="primary">
            Home
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AccessDeniedPage;
